var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCandidIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.515 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".candid_icon_svg__a,.candid_icon_svg__b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.candid_icon_svg__a{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "candid_icon_svg__a",
    d: "M27.097 31.993H20.82a4.06 4.06 0 00-3.726 2.45l-.046.115a6.059 6.059 0 01-3.358 3.231 6.1 6.1 0 01-2.171.4H9.906M32.373 37.243h1.843a5.252 5.252 0 005.252-5.252h-7.262M32.828 44.036h3.968a2.661 2.661 0 002.661-2.661 2.661 2.661 0 00-2.661-2.661h-9.215a2.782 2.782 0 01-.789-.115 2.759 2.759 0 01-1.814-1.728"
  }), /*#__PURE__*/React.createElement("path", {
    className: "candid_icon_svg__a",
    d: "M32.828 49.357h3.968a2.661 2.661 0 002.661-2.661 2.661 2.661 0 00-2.661-2.661h-3.968M31.423 54.679h5.385a2.661 2.661 0 002.661-2.661 2.661 2.661 0 00-2.661-2.661h-3.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "candid_icon_svg__a",
    d: "M35.079 54.678a2.661 2.661 0 012.661 2.66 2.661 2.661 0 01-2.661 2.661h-9.214c-7.614 0-5.183-3.772-15.965-3.772"
  }), /*#__PURE__*/React.createElement("path", {
    className: "candid_icon_svg__b",
    d: "M0 34.619h9.606v24.73H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "candid_icon_svg__b",
    cx: 12.86,
    cy: 12.86,
    r: 12.86,
    transform: "translate(16.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "candid_icon_svg__a",
    d: "M24.506 12.86l3.68 3.68 7.27-7.268"
  }), /*#__PURE__*/React.createElement("path", {
    className: "candid_icon_svg__b",
    d: "M32.206 38.714V25.456M27.097 38.691V25.456"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCandidIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/candid_icon.f1b7065df0c874c85156b15ded22c105.svg";